module.exports = __webpack_public_path__ + "media/homepage/content-experts-8716228c.webp";